import type { BrandInfoProps } from 'types/brandOverview';
import { formatDate } from 'utils';
import PageLayoutSectionView from '../../PageSectionLayout.View';
import BrandIsManaged from '../BrandIsManaged';

const BrandInfoView = ({ brand }: BrandInfoProps) => (
  <PageLayoutSectionView
    sections={[
      {
        label: 'Brand name',
        content: brand?.name
      },
      {
        label: 'Brand URL',
        content: brand?.domain
      },
      {
        label: 'Creation date',
        content: formatDate(brand?.createdAt || new Date().toDateString())
      },
      {
        label: 'Managed by Proxima',
        content: <BrandIsManaged />
      },
      {
        label: 'Dojo Brand ID',
        content: brand?.dojoBrandId
      }
    ]}
  />
);

export default BrandInfoView;
